import { getCookie } from '../utils/cookies';
import { IProfile } from '../types/profile';
import { IEmploymentRole } from '../types/employment-role';
export class ProfileService {
  baseUrl: string;

  constructor({ baseUrl }: { baseUrl: string }) {
    this.baseUrl = baseUrl;
  }

  async getProfile(): Promise<Response> {
    const token = getCookie('enginuity-sp-token');
    return await fetch(`${this.baseUrl}api/v1/profile`, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      })
    });
  }

  async createProfile(): Promise<Response> {
    const token = getCookie('enginuity-sp-token');
    return await fetch(`${this.baseUrl}api/v1/profile`, {
      method: 'PUT',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({
        qualificationIds: [],
        employmentRoles: []
      })
    });
  }

  async saveStatement(statement: string): Promise<IProfile> {
    const token = getCookie('enginuity-sp-token');
    const res = await fetch(`${this.baseUrl}api/v1/profile/personalstatement`, {
      method: 'PATCH',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(statement)
    });
    return await res.json();
  }

  async getPublicProfile(publicId: string): Promise<Response> {
    return await fetch(`${this.baseUrl}api/v1/profile/public/${publicId}`, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json'
      })
    });
  }

  async updateQualifications(qualificationIds: string[]): Promise<IProfile> {
    const token = getCookie('enginuity-sp-token');
    const res = await fetch(`${this.baseUrl}api/v1/profile/qualifications`, {
      method: 'PATCH',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({
        qualifications: qualificationIds
      })
    });
    return await res.json();
  }

  async updateEmploymentRoles(roles: IEmploymentRole[]): Promise<IProfile> {
    const token = getCookie('enginuity-sp-token');
    const res = await fetch(`${this.baseUrl}api/v1/profile/employmentroles`, {
      method: 'PATCH',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({
        employmentRoles: roles
      })
    });
    return await res.json();
  }
}
